<script>
    import { eventGroupState, isSelectedEventGroupLocked } from "@app/store/eventGroupStore.svelte.js";
    import { projectState } from "@app/store/projectStore.svelte.js";
    import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
    import { toast } from "@zerodevx/svelte-toast";
    import autoFormat from "@cclib/functions/eventGroups/autoFormat.js";
    import * as m from '@app/paraglide/messages.js';

    let isDisabled = $derived(!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0 || isSelectedEventGroupLocked());

    /* Compressions makes the event longer which requires us to remove a word from the longest line and move it to a shorter line*/
    const autoFormatEvents = function () {
        try {
            if (isSelectedEventGroupLocked()) {
                toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
                return;
            }

            let maxLines = eventGroupState[projectState.selected]
                ? eventGroupState[projectState.selected].maxLines
                : 2;
            let maxChars = eventGroupState[projectState.selected]
                ? eventGroupState[projectState.selected].maxChars
                : 32;
            let minDuration = eventGroupState[projectState.selected]
                ? eventGroupState[projectState.selected].minDuration
                : 1;

            let tempSelect = [
                ...eventGroupState[projectState.selected].selected,
            ];

            try {
                eventGroupState[projectState.selected] = autoFormat(
                    eventGroupState[projectState.selected],
                    maxLines,
                    maxChars,
                    minDuration,
                    true,
                    eventGroupState[projectState.selected].selected,
                );
            } catch (err) {
                console.log(err.message);
            }

            eventGroupState[projectState.selected].selected = [];
            setTimeout(() => {
                eventGroupState[projectState.selected].selected = tempSelect;
            }, 50);

            toast.push(m.auto_format_toast_success(), {
                classes: ["toast-success"],
            });

            insertHistoryAction({
                name: "auto format", //action name
                eventGroup: projectState.selected,
                snapshots: [
                    {
                        store: "eventGroupState",
                        value: JSON.stringify(eventGroupState),
                    },
                ],
            });
        } catch (err) {
            console.log(err);
            console.log(err.message);
        }
    };
</script>

<li class="nav-item" title={m.auto_format_title()}>
    <a
        class="nav-link"
        href="#!/"
        id="auto-format-btn"
        role="button"
        aria-label={m.auto_format_aria_label()}
        aria-disabled={isDisabled}
        onclick={autoFormatEvents}
        class:disabled={isDisabled}
    >
    <i class="bi bi-check2-square"></i>
    </a>
</li>
